"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPIDS = void 0;
// 不同应用版本对应的appid
exports.APPIDS = {
    index: 1200004,
    vi: 1200009,
    us: 1200014,
    iflix: 1200016,
};
var getCurrentAppid = function () {
    // ua中有video_appid，优先取video_appid
    var appidMatched = navigator.userAgent.match(/video_appid\/([0-9]+)/);
    if (appidMatched && appidMatched.length > 1) {
        return Number(appidMatched[1]);
    }
    // ua中没有video_appid，使用Country后的版本值做映射转换
    var currentPage = 'index';
    var countryMatched = navigator.userAgent.match(/Country\/([0-9]+)\(([a-z-]+)\)/);
    if (countryMatched && countryMatched.length > 2) {
        // ua的国家码固定为：th 国际版、vi 越南版、us 美国、iflix iflix
        currentPage = (countryMatched[2] === 'th') ? 'index' : countryMatched[2];
    }
    return exports.APPIDS[currentPage] || exports.APPIDS.index;
};
var APPID = getCurrentAppid();
exports.default = APPID;
